import qs from 'query-string';
import React from 'react';
import { ButtonGroup } from 'reactstrap';
import { ArcaField } from '../../code/ArcaField';
import { ArcaHttpClientPerson } from '../../code/ArcaHttpClientPerson';
import { ArcaPageFieldState } from '../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaPerson } from '../../code/Types/ArcaPerson';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { InputFieldArray } from '../controls/Fields/InputFieldArray';
import { ModalPopup } from '../controls/ModalPopup';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';

export class PersonEdit extends ArcaComponent {

    constructor(props) {
        super(props);

        const values = qs.parse(this.props.location.search);

        this.state = {
            isLoading: true,
            person: new ArcaPerson(),
            personId: (values.id !== undefined) ? parseInt(values.id) : 0,
            accountWasDeleted: false,
            isError: false,
            statusText: '',
            states: [],
            personTypes: [],
            deletePopupOpen: false,
            formState: new ArcaPageFieldState(),
        };
    }

    componentDidMount() {

        this.getPeopleStates();
        this.getPeopleTypes();

        if (this.state.personId > 0) {
            this.getPersonData(this.state.personId);
        }
    }

    async getPeopleStates() {

        await ArcaHttpClientPerson.GetStatesAsync(
            ((states) => this.setState({ states: states })),
            ((status) => this.props.history.push(`NoPermission: ${status}`)));
    }

    async getPeopleTypes() {

        await ArcaHttpClientPerson.GetTypesAsync(
            ((personTypes) => this.setState({ personTypes: personTypes })),
            ((status) => this.props.history.push(`NoPermission: ${status}`)));
    }

    async getPersonData(personId) {

        await ArcaHttpClientPerson.GetAsync(
            personId,
            (person) => this.setState({
                person: person,
                personId: person.Id,
                isLoading: false,
                formState: this.buildFields(person)
            }),
            (status) => this.props.history.push(`NoPermission: ${status}`));
    }

    async UpdatePerson(person) {
        await ArcaHttpClientPerson.UpdateAsync(
            person,
            (() => {
                this.setState({
                    isError: false,
                    statusText: "Your details have been updated",
                    person: person,
                    formState: this.buildFields(person)
                });
            }),
            (message => this.setState({
                isError: true,
                statusText: message,
            })));
    }

    async AddPerson(person) {
        await ArcaHttpClientPerson.AddAsync(
            person,
            ((newId) => {
                person.Id = newId;
                this.setState({
                    isError: false,
                    statusText: "Your details have been updated",
                    person: person
                });
            }),
            (message => this.setState({
                isError: true,
                statusText: message,
            })));
    }

    async onSubmit() {
        let { person } = this.state;

        var isNew = (this.state.person.Id === 0);

        if (isNew) {
            this.AddPerson(person)
        }
        else {
            this.UpdatePerson(person)
        }
    }

    render() {
        const buttonWidth = '140px';
        let { accountWasDeleted, person, deletePopupOpen, formState, isLoading } = this.state;
        let enableUpdate = formState !== null && (formState.IsValid && formState.HasChanged)
        let showMandatoryWarning = formState !== null && !formState.IsValid && formState.HasChanged

        let buttons = <div className='centerText'>
            <ButtonGroup>

                {!accountWasDeleted && formState.IsValid && formState.HasChanged
                    ? <ArcaLink
                        colour='primary'
                        width={buttonWidth}
                        onClick={this.onSubmit.bind(this)}
                        disabled={!enableUpdate}
                        text='Update' />
                    : null}

                {person.Id > 0
                    ? <ArcaLink
                        text='View'
                        width={buttonWidth}
                        link={'/PersonView/?id=' + this.state.personId}
                        colour='secondary' />
                    : null}

                {person.Id > 0 && ArcaSecurity.IsAdmin
                    ? <ArcaLink
                        colour="secondary"
                        width={buttonWidth}
                        text='Delete'
                        onClick={() => this.setState({ deletePopupOpen: true })} />
                    : null}

            </ButtonGroup>
            {showMandatoryWarning
                ? <StatusBar isError={false} message={'Please make sure all mandatory fields (marked with *) are filled'} />
                : null}
        </div>

        return (
            <div>
                {isLoading
                    ? (<p><em>Loading...</em></p>)
                    : (
                        <div>
                            <h1 className='centerText' id="tabelLabel">{person?.FirstName} {person?.LastName}</h1>
                            {buttons}

                            <StatusBar isError={this.state.isError} message={this.state.statusText} />
                            <div>

                                {deletePopupOpen
                                    ? <ModalPopup
                                        onConfirm={this.deletePerson.bind(this)}
                                        onCancel={() => this.setState({ deletePopupOpen: false })}
                                        title="Delete Account Completely"
                                        text="Are you really sure you want to delete this account. There is not coming back." />
                                    : null}

                                <InputFieldArray
                                    formState={formState}
                                    onUpdate={this.onUpdate.bind(this)} />

                                <hr />

                            </div>
                        </div >)}
            </div>
        );
    }

    async onUpdate(value, isValid, fieldName) {

        let { person, formState } = this.state

        var field = formState.GetField(fieldName);

        field.Value = value
        field.IsValid = isValid
        person[fieldName] = value

        this.setState({
            person,
        });
    }

    async deletePerson() {
        ArcaHttpClientPerson.DeletePerson(
            this.state.person.Id,
            (message => this.setState({
                accountWasDeleted: false,
                statusText: "This account has been deleted!",
                isSaved: true,
                deletePopupOpen: false
            })),
            (message =>
                this.setState({
                    isError: true,
                    statusText: message,
                    accountWasDeleted: false,
                    deletePopupOpen: false
                })))
    }

    buildFields(person) {

        let formState = new ArcaPageFieldState()

        if (ArcaSecurity.IsAdmin) {
            formState.AddField(new ArcaField("State", "State", person.State, true, true, 'select', 'UserState'));
            formState.AddField(new ArcaField("Type", "Type", person.Type, true, true, 'select', 'UserType'));
        }

        formState.AddField(new ArcaField("First Name", "FirstName", person.FirstName, true, true, 'text', 'name'));
        formState.AddField(new ArcaField("Middle Name", "MiddleName", person.MiddleName, true, false, 'text', 'name'));
        formState.AddField(new ArcaField("Last Name", "LastName", person.LastName, true, true, 'text', 'name'));

        formState.AddField(new ArcaField("Email Address", "Email", person.Email, true, true, 'text', 'email'));
        formState.AddField(new ArcaField("2nd Email Address", "Email2", person.Email2, true, false, 'text', 'email'));

        formState.AddField(new ArcaField("Address Line 1", "AddressLine1", person.AddressLine1, person.AddressLine1 !== '', true, 'text', 'address'));
        formState.AddField(new ArcaField("Address Line 2", "AddressLine2", person.AddressLine2, true, false, 'text', 'address'));
        formState.AddField(new ArcaField("Postcode", "Postcode", person.Postcode, true, false, 'text', 'postcode'));

        formState.AddField(new ArcaField("Second Owner", "SecondOwner", person.SecondOwner, true, false, 'text', 'name'));

        formState.AddField(new ArcaField("Mobile Number", "Mobile", person.Mobile, true, false, 'text', 'phone'));
        formState.AddField(new ArcaField("Mobile Number 2", "Mobile2", person.Mobile2, true, false, 'text', 'phone'));
        formState.AddField(new ArcaField("Home Number", "Home", person.Home, true, false, 'text', 'phone'));

        if (person.Type === 'Walker') {
            formState.AddField(new ArcaField("Covered Postcodes", "CoveredPostcodes", person.CoveredPostcodes, true, true, 'text', 'none'));
        }

        return formState;
    }
}
